import { EMPTY_IMMUTABLE_MAP } from '@lacele/const'
import { makePath } from '@lacele/utils'

export const defaultState = EMPTY_IMMUTABLE_MAP

export default class Reducer {

    constructor(delegateReducer, subReducers) {
        this.delegateReducer = delegateReducer
        this.subReducers = subReducers
        this.reducer = this.reducer.bind(this)
    }

    reducerWillMount(dynamicReducer, storeTarget) {
        this.dynamicReducer = dynamicReducer
        this.storeTarget = storeTarget
    }

    reducerDidMount() {
        Object.keys(this.subReducers).forEach((subReducerKey) => {
            const subReducerFunc = this.subReducers[subReducerKey]
            this.dynamicReducer.addTarget(makePath(this.storeTarget, subReducerKey), subReducerFunc)
        })
    }

    reducerWillUnmount() {
        Object.keys(this.subReducers).forEach((subReducerKey) => {
            this.dynamicReducer.removeTarget(makePath(this.storeTarget, subReducerKey))
        })
    }

    reducer(state, action) {
        if (this.delegateReducer) {
            return this.delegateReducer(state, action)
        }
        return state || defaultState
    }
}
